var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reportType==0)?_c('iframe',{attrs:{"name":"child","id":"child","src":_vm.reportUrl,"width":"100%","height":"100%","frameborder":"0","scrolling":"no"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }